import type { TicketPriority } from "@sagot/constants";
import type { IconName } from "../../icons";
import { Chip, type ChipSize, type ChipTone } from "./chip";

/** Mockup `D.priorities`: the shape (icon) carries the level as well as the colour. */
export const PRIORITY_CHIP: Readonly<Record<TicketPriority, { tone: ChipTone; icon: IconName }>> = {
  urgent: { tone: "danger", icon: "alert-octagon" },
  high: { tone: "warning", icon: "arrow-up" },
  normal: { tone: "muted", icon: "minus" },
  low: { tone: "muted", icon: "arrow-down" },
};

export interface PriorityBadgeProps {
  priority: TicketPriority;
  /** Localised level name ("Urgent"). */
  label: string;
  size?: ChipSize;
  className?: string;
}

export function PriorityBadge({ priority, label, size = "md", className }: PriorityBadgeProps) {
  const spec = PRIORITY_CHIP[priority];
  return (
    <Chip tone={spec.tone} icon={spec.icon} size={size} className={className} data-priority={priority}>
      {label}
    </Chip>
  );
}
